module.exports = __webpack_public_path__ + "img/logo.6481ffe4.png";